import {Helper} from "../../../helper";

export const fileInput = {
	props:      ['maxFiles', 'count'],
	data() {
		return {
			postAction: document.environments.adminAjax,
			data:       {
				action: 'uploadInquiryFile'
			},
			loading:    false,
			files:      [],
			maxSize:    1024 * 1024 * 8,
			accept:     '*',
			extensions: 'gif,jpg,jpeg,png,webp,doc,docx,xdoc,pdf,'
		};
	},
	methods:    {
		errors(key) {
			let errors = {
				extension: 'Nepovelený typ souboru.'
			};

			if(key !== 'extension') {
				errors[key] = 'Soubor je příliš velký, maximální velikost je ' + Helper.bytesToSize(this.maxSize);
			}

			if(errors[key]) {
				return errors[key];
			}

			return key;
		},
		/**
		 * Has changed
		 * @param  Object|undefined   newFile   Read only
		 * @param  Object|undefined   oldFile   Read only
		 * @return undefined
		 */
		inputFile: function(newFile, oldFile) {
			if(newFile && oldFile && !newFile.active && oldFile.active) {

				// Uploaded successfully
				if(newFile.success !== oldFile.success && newFile.response && !newFile.response.error) {
					let filename = newFile.file.name;
					let filesize = newFile.file.size;
					let path     = newFile.response.path;
					let url      = newFile.response.url;
					let src      = newFile.response.src;
					this.$emit('sendFileToParent', {
						filename,
						filesize,
						path,
						url,
						src
					});
					this.loading = false;
					this.$emit('sendEnabledBtnToParent');
					this.$emit('fileUploading', this.loading);

				} else {
					let fileError = this.errors(newFile.response.error ? newFile.response.error : newFile.error);
					this.$emit('sendFileErrorToParent', fileError);
					this.loading = false;
					this.$emit('sendEnabledBtnToParent');
					this.$emit('fileUploading', this.loading);
				}
			}


			// Automatic upload
			if(Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
				if(!this.$refs.upload.active) {
					this.$refs.upload.active = true;
					this.loading             = true;
					this.$emit('sendDisabledBtnToParent');
					this.$emit('fileUploading', this.loading);
				}
			}

		}
	}
};